import React from "react";
import PropTypes from "prop-types";
import Fade from "react-reveal/Fade";
import classnames from "classnames";

export default function Animate({ children, className = "" }) {
  const fullscreenClasses = classnames("fullscreen", className);

  return (
    <div className={fullscreenClasses}>
      <Fade right duration={500} delay={200}>
        <div className="content-wrapper">{children}</div>
      </Fade>
    </div>
  );
}

Animate.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
    .isRequired,
  className: PropTypes.string,
};
